import React, { Component } from 'react';

import './MarkerInfoBubble.css';

export default class InfoBubble extends Component {
  render() {
    const { title, content } = this.props;
    return (
      <div className="MarkerInfoBubble">
        <div className="header">{title}</div>
        <div className="content">{content}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Map/MarkerInfoBubble/MarkerInfoBubble.js